import { toast as sonnerToast } from "sonner";

const DEFAULT_DURATION = 5000;

const mapOptions = (options = {}) => {
  if (!options || typeof options !== "object") return { duration: DEFAULT_DURATION };

  const {
    autoClose,
    className,
    description,
    duration,
    icon,
    id,
    richColors,
    closeButton,
    action,
    cancel,
    ...rest
  } = options;

  const resolvedDuration =
    typeof autoClose === "number"
      ? autoClose
      : autoClose === false
        ? Infinity
        : typeof duration === "number"
          ? duration
          : DEFAULT_DURATION;

  return {
    ...rest,
    action,
    cancel,
    className,
    closeButton,
    description,
    duration: resolvedDuration,
    icon,
    id,
    richColors,
  };
};

const baseToast = (message, options) => sonnerToast(message, mapOptions(options));

baseToast.success = (message, options) => sonnerToast.success(message, mapOptions(options));
baseToast.error = (message, options) => sonnerToast.error(message, mapOptions(options));
baseToast.info = (message, options) => sonnerToast.info(message, mapOptions(options));
baseToast.warn = (message, options) => sonnerToast.warning(message, mapOptions(options));
baseToast.warning = (message, options) => sonnerToast.warning(message, mapOptions(options));
baseToast.loading = (message, options) => sonnerToast.loading(message, mapOptions(options));
baseToast.dismiss = (toastId) => sonnerToast.dismiss(toastId);
baseToast.remove = (toastId) => sonnerToast.dismiss(toastId);
baseToast.message = (message, options) => sonnerToast.message(message, mapOptions(options));
baseToast.custom = (jsx, options) => sonnerToast.custom(jsx, mapOptions(options));

export const toast = baseToast;
